import React from 'react';

import type { Reference } from '@swf/cms';
import Link from '@swf/components/Link/Link';

import BrandIcon from '../BrandIcon/BrandIcon';

interface Props {
  brandIcon: Reference[];
  brandIconUrl?: string;
  inMenu?: boolean;
  onClick?: React.MouseEventHandler<HTMLAnchorElement>;
  dataTestId?: string;
}

const BrandIconButton: React.FC<Props> = ({
  brandIcon,
  brandIconUrl,
  inMenu,
  onClick,
  dataTestId
}) =>
  brandIconUrl ? (
    <Link
      href={brandIconUrl}
      track
      trackText="Brand Icon"
      onClick={onClick}
      data-testid={dataTestId}
    >
      <BrandIcon brandIcon={brandIcon} inMenu={inMenu} />
    </Link>
  ) : (
    <BrandIcon brandIcon={brandIcon} inMenu={inMenu} />
  );

export default BrandIconButton;
